import { SeuEnvironment } from '../types/environment.type';

export function getMSALRedirectUrl(env: SeuEnvironment): string {
  if (typeof env.msal.redirectUrl === 'string') {
    return env.msal.redirectUrl;
  }
  const location = window.location.href;
  if (location.includes('processdesigner.scheuch.com')) {
    return env.msal.redirectUrl.cdnUrl;
  }
  if (location.includes('storeweb.z6.web.core.windows.net')) {
    return env.msal.redirectUrl.azureUrl;
  }
  return '';
}
